module.exports = __webpack_public_path__ + "img/dialpad.7e4c6278.png";